import { useTranslation } from 'react-i18next';

import { PublicCustomDataOptions, useCompanyData } from '~/data/company';

import { EmployeeModuleTabPath_People } from '../../PeopleModule/data';
import { EmployeeModuleTabSetupProps } from '../../types';

export interface UsePublicCustomDataTabsOutPut {
  publicCustomDataTabs: EmployeeModuleTabPath_People[];
  tabsPropsPublicCustomData: EmployeeModuleTabSetupProps<EmployeeModuleTabPath_People>[];
}

export const usePublicCustomDataTabs = (): UsePublicCustomDataTabsOutPut => {
  const { t } = useTranslation();
  const {
    companyData: {
      config: { fComPublicCustomdata },
    },
  } = useCompanyData();
  const fComPublicCustomdataIndexed = fComPublicCustomdata.reduce(
    (acc, data) => ({
      ...acc,
      [data]: data,
    }),
    {} as Record<PublicCustomDataOptions, PublicCustomDataOptions>,
  );

  const publicCustomDataTabs: EmployeeModuleTabPath_People[] = [];

  if (fComPublicCustomdataIndexed[PublicCustomDataOptions.EMPLOYEE]) {
    publicCustomDataTabs.push(EmployeeModuleTabPath_People.CustomData);
  }
  if (fComPublicCustomdataIndexed[PublicCustomDataOptions.EMPLOYEE_POS]) {
    publicCustomDataTabs.push(EmployeeModuleTabPath_People.JobDescription);
  }

  const tabsPropsPublicCustomData: EmployeeModuleTabSetupProps<EmployeeModuleTabPath_People>[] =
    [];

  if (fComPublicCustomdataIndexed[PublicCustomDataOptions.EMPLOYEE])
    tabsPropsPublicCustomData.push({
      id: EmployeeModuleTabPath_People.CustomData,
      title: t('laCustomData'),
    });
  if (fComPublicCustomdataIndexed[PublicCustomDataOptions.EMPLOYEE_POS])
    tabsPropsPublicCustomData.push({
      id: EmployeeModuleTabPath_People.JobDescription,
      title: t('laPositionCustomData'),
    });

  return {
    publicCustomDataTabs,
    tabsPropsPublicCustomData,
  };
};
